export default class FlipdotDisplay {
    constructor() {
        this.root = null;
        this.columns = 10;
        this.rows = 5;
        this.dots = [];
        this.audioEnabled = false;
        this.animationStep = 0; // Tracks which animation should play
    }

    init(root) {
        this.root = root;
        this.updateGrid();
        window.addEventListener("resize", () => this.updateGrid());

        this.button = document.querySelector(".flipdotdisplay-button");
        if (this.button) {
            this.button.addEventListener("click", () => this.runAnimations());
        }
    }

    updateGrid() {
        const containerWidth = this.root.clientWidth;
        let dotSize = Math.floor(containerWidth / this.columns);
        dotSize = Math.max(24, Math.min(50, dotSize));
        this.columns = Math.floor(containerWidth / dotSize);
        dotSize = containerWidth / this.columns;
        this.rows = Math.min(8, Math.floor(this.columns / 2));

        this.root.innerHTML = "";
        this.dots = [];
        this.root.style.gridTemplateColumns = `repeat(${this.columns}, ${dotSize}px)`;

        for (let i = 0; i < this.rows * this.columns; i++) {
            const dot = document.createElement("div");
            dot.classList.add("flipdot");
            dot.dataset.active = "false";
            dot.style.width = `${dotSize}px`;
            dot.style.height = `${dotSize}px`;
            dot.addEventListener("mouseenter", () => this.hoverDot(dot));
            dot.addEventListener("click", () => this.toggleDot(dot));
            this.dots.push(dot);
            this.root.appendChild(dot);
        }
    }

    hoverDot(dot) {
        if (dot.dataset.active === "true") return;
        dot.dataset.active = "hover";
        this.playSound("./assets/audio/flip-on-2.mp3");
        setTimeout(() => {
            if (dot.dataset.active === "hover") {
                dot.dataset.active = "false";
                this.playSound("./assets/audio/flip-off-2.mp3");
            }
        }, 800);
    }

    toggleDot(dot) {
        this.audioEnabled = true;
        if (dot.dataset.active === "true") {
            dot.dataset.active = "false";
            this.playSound("./assets/audio/flip-off-2.mp3");
        } else if (dot.dataset.active === "hover") {
            dot.dataset.active = "true";
        } else {
            dot.dataset.active = "true";
            this.playSound("./assets/audio/flip-on-2.mp3");
        }
    }

    playSound(src) {
        if (!this.audioEnabled) return;
        const audio = new Audio(src);
        audio.play();
    }

    runAnimations() {
        this.button.classList.add('pressed');
        setTimeout(() => this.button.classList.remove('pressed'), 200);

        if (this.animationStep === 0) {
            this.animateColumns();
        } else if (this.animationStep === 1) {
            this.animateChessboard();
        } else if (this.animationStep === 2) {
            this.animateRandom();
        }

        this.animationStep = (this.animationStep + 1) % 3; // Cycle back to 0 after 2
    }

    animateColumns() {
        const columns = this.columns;
        const rows = this.rows;

        for (let col = 0; col < columns; col++) {
            setTimeout(() => {
                for (let row = 0; row < rows; row++) {
                    const index = row * columns + col;
                    if (this.dots[index] && this.dots[index].dataset.active === "false") {
                        this.dots[index].dataset.active = "true";
                    }
                }
                this.playSound("./assets/audio/flip-on-2.mp3");

                setTimeout(() => {
                    for (let row = 0; row < rows; row++) {
                        const index = row * columns + col;
                        if (this.dots[index] && this.dots[index].dataset.active === "true") {
                            this.dots[index].dataset.active = "false";
                        }
                    }
                    this.playSound("./assets/audio/flip-off-2.mp3");
                }, 1600);
            }, col * 75);
        }
    }

    animateChessboard() {
        const dots = this.dots;
        const togglePattern = (pattern) => {
            dots.forEach((dot, index) => {
                if ((index % this.columns + Math.floor(index / this.columns)) % 2 === pattern) {
                    dot.dataset.active = "true";
                } else {
                    dot.dataset.active = "false";
                }
            });
            this.playSound("./assets/audio/flip-on-2.mp3");
        };

        togglePattern(0);
        setTimeout(() => {
            togglePattern(1);
            setTimeout(() => {
                dots.forEach(dot => dot.dataset.active = "false");
                this.playSound("./assets/audio/flip-off-2.mp3");
            }, 1000);
        }, 1000);
    }

    animateRandom() {
        const dots = this.dots;
        let iterations = 5;

        const randomToggle = () => {
            for (let i = 0; i < dots.length / 2; i++) {
                const index = Math.floor(Math.random() * dots.length);
                dots[index].dataset.active = dots[index].dataset.active === "true" ? "false" : "true";
            }
            this.playSound("./assets/audio/flip-on-2.mp3");
        };

        const interval = setInterval(() => {
            randomToggle();
            iterations--;
            if (iterations === 0) {
                clearInterval(interval);
                setTimeout(() => {
                    dots.forEach(dot => dot.dataset.active = "false");
                    this.playSound("./assets/audio/flip-off-2.mp3");
                }, 200);
            }
        }, 200);
    }
}
